module.exports = __webpack_public_path__ + "static/media/icon-release.16aef9c1.svg";